import { DraasApiProviderDatastoreUsageStatus } from '@pure/paas-api-gateway-client-ts';

export class DisasterRecoveryProviderStorageUsage {
    readonly providerId: string;
    readonly providerName?: string;
    readonly consumedBytes: number;
    readonly quotaBytes: number;

    constructor(json: DraasApiProviderDatastoreUsageStatus) {
        this.providerId = json.provider_id;
        this.providerName = json.provider_name;
        this.consumedBytes = json.consumed_bytes;
        this.quotaBytes = json.quota_bytes;
    }
}
